import React, { useState, useEffect } from 'react';
import Button from '../../ui/Button';
import AddressAutocomplete from '../../shared/AddressAutocomplete';

/**
 * Etapa de cadastro de endereço do negócio
 */
const AddressStep = ({ onNext, onBack, initialData = {} }) => {
  const [address, setAddress] = useState(initialData.address || {});
  const [isValid, setIsValid] = useState(false);
  
  // Verificar se todos os campos obrigatórios estão preenchidos
  const validateAddress = (addressData) => {
    return !!(
      addressData.cep &&
      addressData.street &&
      addressData.number &&
      addressData.neighborhood &&
      addressData.city &&
      addressData.state
    );
  };

  // Verificar a validade do endereço inicial quando o componente carrega
  useEffect(() => {
    if (initialData.address) {
      setIsValid(validateAddress(initialData.address));
    }
  }, [initialData.address]);
  
  // Atualizar o estado do endereço
  const handleAddressChange = (newAddressData) => {
    setAddress(newAddressData);
    setIsValid(validateAddress(newAddressData));
  };
  
  // Formatar endereço completo
  const formatFullAddress = () => {
    if (!validateAddress(address)) return '';
    
    let formattedAddress = `${address.street}, ${address.number}`;
    
    if (address.complement) {
      formattedAddress += ` - ${address.complement}`;
    }
    
    formattedAddress += ` - ${address.neighborhood}, ${address.city} - ${address.state}`;
    
    return formattedAddress;
  };
  
  // Enviar dados e ir para o próximo passo
  const handleContinue = () => {
    // Criar o objeto de endereço completo com formato legível
    const fullAddress = {
      ...address,
      formattedAddress: formatFullAddress()
    };
    
    onNext({ address: fullAddress });
  };
  
  return (
    <div className="animate-fadeIn">
      <h2 className="text-2xl font-semibold text-center text-gray-800 mb-3">
        Qual é o endereço do seu negócio?
      </h2>
      <p className="text-gray-600 text-center mb-8">
        Este endereço será exibido para seus clientes
      </p>
      
      <div className="mb-8">
        <AddressAutocomplete 
          initialData={address}
          onAddressChange={handleAddressChange}
        />
      </div>
      
      <div className="flex justify-between">
        <Button 
          type="button" 
          variant="outlined"
          onClick={onBack}
        >
          Voltar
        </Button>
        
        <Button 
          type="button" 
          onClick={handleContinue}
          disabled={!isValid}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
};

export default AddressStep; 